import Apple from './Apple.png';
import Ball from './Ball.png';
import CardBack from './CardBack.svg';
import Chicken from './Chicken.png';
import Cow from './Cow.png';
import ImportIndexCards from './ImportIndexCards.png';
import ImportJiraCards from './ImportJiraCards.png';
import ImportStickies from './ImportStickies.png';
import ImportStickiesInTopics from './ImportStickiesInTopics.png';
import ImportStickiesInZones from './ImportStickiesInZones.png';
import ImportTaskCards from './ImportTaskCards.png';
import ImportText from './ImportText.png';
import ImportTokens from './ImportTokens.png';
import Logo from './Logo.svg';
import LogoBlue from './LogoBlue.svg';
import LogoBlue2 from './LogoBlue2.svg';
import LogoFullBlue from './LogoFullBlue.svg';
import LogoFullOutline from './LogoFullOutline.svg';
import LogoOutline from './LogoOutline.svg';
import LogoWhite from './LogoWhite.svg';
import PaymentCards from './PaymentCards.png';
import SebBlue from './SebBlue.svg';
import SebSprite from './SebSprite.svg';
import SebSpriteAlt from './SebSpriteAlt.svg';
import SebSpriteNew from './SebSpriteNew.svg';
import SebWhiteOutline from './SebWhiteOutline.svg';
import SebXmasHat from './SebXmasHat.svg';
import SebXmasHatBlue from './SebXmasHatBlue.svg';
import XmasBells from './XmasBells.svg';
import XmasBow from './XmasBow.svg';
import XmasHolly from './XmasHolly.svg';
import XmasOrnament1 from './XmasOrnament1.svg';
import XmasOrnament2 from './XmasOrnament2.svg';
import XmasOrnament3 from './XmasOrnament3.svg';
import XmasOrnament4 from './XmasOrnament4.svg';
import XmasOrnament5 from './XmasOrnament5.svg';
import XmasSnow1 from './XmasSnow1.svg';
import XmasSnow2 from './XmasSnow2.svg';
import XmasSnow3 from './XmasSnow3.svg';
import XmasSnow4 from './XmasSnow4.svg';
import XmasSnow5 from './XmasSnow5.svg';
import XmasSnowflake from './XmasSnowflake.svg';
import XmasSnowman from './XmasSnowman.svg';
import XmasSock from './XmasSock.svg';
import XmasStar1 from './XmasStar1.svg';
import XmasStar2 from './XmasStar2.svg';
import XmasTinsel from './XmasTinsel.svg';
import XmasTree from './XmasTree.svg';
import XmasTreeNew from './XmasTreeNew.svg';
import XmasWreath from './XmasWreath.svg';

export const Images = {
    Apple,
    Ball,
    CardBack,
    Chicken,
    Cow,
    ImportIndexCards,
    ImportJiraCards,
    ImportStickies,
    ImportStickiesInTopics,
    ImportStickiesInZones,
    ImportTaskCards,
    ImportText,
    ImportTokens,
    Logo,
    LogoBlue,
    LogoFullOutline,
    LogoWhite,
    PaymentCards,
    SebBlue,
    SebSprite,
    SebSpriteAlt,
    SebSpriteNew,
    SebWhiteOutline,
    SebXmasHat,
    SebXmasHatBlue,
    XmasBells,
    XmasBow,
    XmasHolly,
    XmasOrnament1,
    XmasOrnament2,
    XmasOrnament3,
    XmasOrnament4,
    XmasOrnament5,
    XmasSnow1,
    XmasSnow2,
    XmasSnow3,
    XmasSnow4,
    XmasSnow5,
    XmasSnowflake,
    XmasSnowman,
    XmasSock,
    XmasStar1,
    XmasStar2,
    XmasTinsel,
    XmasTree,
    XmasTreeNew,
    XmasWreath,
    LogoBlue2,
    LogoFullBlue,
    LogoOutline,
};
